import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, NavLink, useLocation, useParams } from "react-router-dom";
import IconsGen from "../../../icons_generator/IconsGen";  

const Warehouse = ({ direction }) => {
  const [_] = useTranslation("global");
  const { slug, lang } = useParams();
  const role = localStorage.getItem("role");
  const employee_type = localStorage.getItem("employee_type");
  const [isSubNavVisible, setIsSubNavVisible] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.includes("/panel/warehouse/")) {
      setIsSubNavVisible(true);
    }else{
      setIsSubNavVisible(false);

    }
  }, [location.pathname]);
  const handleClick = () => {
    setIsSubNavVisible(!isSubNavVisible);
  }; 
  const currentUserId = localStorage.getItem("user_id");  
  console.log({currentUserId});
  
  if (currentUserId === "16321" && slug === "ae") {
      return null;
  }
  return (
    <div className="links-container d-flex flex-column">
      
      <div className="d-flex flex-column">
        <div
          className={`feature_link ${
            lang === "en" ? "feature_link_en" : ""
          } d-flex flex-row-reverse align-items-center gap-2 py-3           
          ${isSubNavVisible ? 'active-link' : ''}`}

          dir={direction}
          // to={`/${slug}/${lang}/panel/warehouse`}
          onClick={handleClick}

        >
          <IconsGen icon_name={"warehouse"} />
          <p>{_("panel.warehouse")}</p>
        </div>
        <ul className={`${isSubNavVisible ? 'd-flex' : 'd-none'} sub-nav flex-column gap-2 px-5 pt-3`}>
          {role == "admin" || employee_type == 'warehouse employee' ? (
            <>
              <li>
                <NavLink to={`/${slug}/${lang}/panel/warehouse/warehouses`}>
                  <p className="d-inline ">{_("panel.warehouses")}</p>
                </NavLink>
              </li>
             
            </>
          ) : (
            ""
          )}
          <li>
            <NavLink to={`/${slug}/${lang}/panel/warehouse/products-stock`}>
              <p className="d-inline ">{_("panel.productsStock")}</p>
            </NavLink>
          </li>
          {role == "admin" || employee_type == 'warehouse employee' || employee_type == 'operation employee' ? (
            <>
              <li>
                <NavLink to={`/${slug}/${lang}/panel/warehouse/variants-stock`}>
                  <p className="d-inline ">{_("panel.variantsStock")}</p>
                </NavLink>
              </li>
             
              
            </>
          ) : (
            ""
          )}
            { employee_type == "warehouse employee" &&
                <li>
                  <NavLink to={`/${slug}/${lang}/panel/warehouse/pickup-report`}>
                    <p className="d-inline ">{_("panel.pickupReport")}</p>
                  </NavLink>
                </li>
             }
            {(role == "admin" || employee_type == "warehouse employee") && (
              <li>
                <NavLink to={`/${slug}/${lang}/panel/warehouse/cancels`}>
                  <p className="d-inline ">{_("panel.Cancels")}</p>
                </NavLink>
              </li>
            )}
        </ul>
      </div>
    </div>
  );
};

export default Warehouse;
